/* FamilyMatch — envoi du dessin : validation, aperçu, remplacement, progression.
   Le fichier part dans le formulaire produit standard (propriété de ligne), Shopify le stocke.
   product-form.js appelle window.FmDrawingUpload.validate(form) avant l'ajout et
   window.FmDrawingUpload.progress(form, pct) / .reset(form) pendant l'envoi. */
(function () {
  const MB = 1024 * 1024;
  const OK_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
  const OK_EXT = /\.(jpe?g|png|webp|heic|heif)$/i;

  class FmDrawingUpload extends HTMLElement {
    connectedCallback() {
      this.maxMb = parseFloat(this.dataset.maxMb) || 20;
      this.input = this.querySelector('[data-fm-input]');
      this.filename = this.querySelector('[data-fm-filename]');
      this.zone = this.querySelector('[data-fm-zone]');
      this.empty = this.querySelector('[data-fm-empty]');
      this.preview = this.querySelector('[data-fm-preview]');
      this.thumb = this.querySelector('[data-fm-thumb]');
      this.nopreview = this.querySelector('[data-fm-nopreview]');
      this.nameEl = this.querySelector('[data-fm-name]');
      this.sizeEl = this.querySelector('[data-fm-size]');
      this.okEl = this.querySelector('[data-fm-ok]');
      this.progress = this.querySelector('[data-fm-progress]');
      this.bar = this.querySelector('[data-fm-bar]');
      this.pct = this.querySelector('[data-fm-pct]');
      this.error = this.querySelector('[data-fm-error]');
      this.form = this.closest('form');

      this.input.addEventListener('change', () => this.onFile(this.input.files[0]));
      this.querySelector('[data-fm-replace]').addEventListener('click', (e) => { e.preventDefault(); this.input.click(); });
      this.querySelector('[data-fm-remove]').addEventListener('click', (e) => { e.preventDefault(); this.clear(); });
      this.zone.addEventListener('click', (e) => {
        if (e.target.closest('button') || e.target === this.input) return;
        this.input.click();
      });
      this.zone.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.input.click(); }
      });
      ['dragenter', 'dragover'].forEach((ev) => this.zone.addEventListener(ev, (e) => { e.preventDefault(); this.zone.classList.add('is-dragover'); }));
      ['dragleave', 'drop'].forEach((ev) => this.zone.addEventListener(ev, (e) => { e.preventDefault(); this.zone.classList.remove('is-dragover'); }));
      this.zone.addEventListener('drop', (e) => {
        const file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (!file) return;
        try {
          const dt = new DataTransfer();
          dt.items.add(file);
          this.input.files = dt.files;
        } catch (_) { /* navigateurs sans DataTransfer : on garde la sélection manuelle */ }
        this.onFile(file);
      });

      this.teeSrc = this.dataset.teeSrc || '';
      this.area = (this.dataset.printArea || '0.31,0.16,0.38,0.40').split(',').map(Number);
      this.detour = this.dataset.detourage !== 'false';
      this.mock = this.querySelector('[data-fm-mock]');
      if (this.mock && this.teeSrc) {
        this.mock.style.backgroundImage = `url("${this.teeSrc}")`;
        this.placePrint(this.thumb, this.mock, null);
      }
      this.bgToggle = this.querySelector('[data-fm-bgtoggle]');
      if (this.bgToggle) this.bgToggle.addEventListener('click', (e) => { e.preventDefault(); this.showOriginal = !this.showOriginal; this.applyPreview(); });
      this.onResize = () => { if (this.mockBox) this.placeMockup(); if (this.zoneBox) this.placeZone(); };
      window.addEventListener('resize', this.onResize);
      /* cadre de la zone d'impression : seulement dans l'éditeur de thème (réglage de la zone) */
      if (this.dataset.showZone === '1') this.renderZone();

      this.syncSubmit();
    }

    disconnectedCallback() { window.removeEventListener('resize', this.onResize); }

    /* ---- Aperçu sur le tee-shirt ----
       Le dessin (détouré par fm-detourage.js, sinon la photo d'origine) est posé dans la zone d'impression
       de l'image du tee-shirt blanc (fractions de l'image, réglables dans l'éditeur de thème),
       en mode « produit » (multiply) pour se fondre dans le tissu comme à l'impression. */
    placePrint(el, frame, rect) {
      const [x, y, w, h] = this.area;
      if (!rect) { /* cadre aux proportions exactes du tee-shirt : positions en % */
        Object.assign(el.style, { left: `${x * 100}%`, top: `${y * 100}%`, width: `${w * 100}%`, height: `${h * 100}%` });
        return;
      }
      Object.assign(el.style, {
        left: `${rect.left + x * rect.width}px`, top: `${rect.top + y * rect.height}px`,
        width: `${w * rect.width}px`, height: `${h * rect.height}px`,
      });
    }

    galleryMedia() {
      const scope = this.closest('product-info') || this.closest('section') || document;
      return scope.querySelector('.product__media-list .product__media-item:first-child .product__media') || scope.querySelector('.product__media');
    }

    imageRect(media) {
      const img = media.querySelector('img');
      const mw = media.clientWidth, mh = media.clientHeight;
      const nw = (img && img.naturalWidth) || 1694, nh = (img && img.naturalHeight) || 2000;
      const fit = img ? getComputedStyle(img).objectFit : 'contain';
      const sc = fit === 'cover' ? Math.max(mw / nw, mh / nh) : (fit === 'fill' ? null : Math.min(mw / nw, mh / nh));
      return sc == null ? { left: 0, top: 0, width: mw, height: mh } : { left: (mw - nw * sc) / 2, top: (mh - nh * sc) / 2, width: nw * sc, height: nh * sc };
    }

    placeMockup() {
      const media = this.mockMedia; const box = this.mockBox;
      if (!media || !box) return;
      this.placePrint(box.querySelector('.fm-mockup__print'), media, this.imageRect(media));
    }

    renderZone() {
      const media = this.galleryMedia();
      if (!media) return;
      let z = media.querySelector('.fm-zone');
      if (!z) {
        z = document.createElement('span');
        z.className = 'fm-zone';
        const [x, y, w, h] = this.area;
        z.innerHTML = `<span class="fm-zone__label">Zone d'impression · gauche ${Math.round(x * 1000) / 10} % · haut ${Math.round(y * 1000) / 10} % · largeur ${Math.round(w * 1000) / 10} % · hauteur ${Math.round(h * 1000) / 10} %</span>`;
        media.appendChild(z);
      }
      this.zoneMedia = media; this.zoneBox = z;
      const img = media.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', () => this.placeZone(), { once: true });
      this.placeZone();
    }

    placeZone() { if (this.zoneMedia && this.zoneBox) this.placePrint(this.zoneBox, this.zoneMedia, this.imageRect(this.zoneMedia)); }

    /* affiche le dessin détouré (ou la photo d'origine pour comparer) dans la miniature et sur le tee-shirt */
    applyPreview() {
      const cut = !this.showOriginal && !!this.processedUrl;
      const url = cut ? this.processedUrl : (this.originalIsImage ? this.originalUrl : this.processedUrl);
      if (!url) return;
      this.thumb.src = url;
      this.thumb.hidden = false;
      this.nopreview.hidden = true;
      this.thumb.classList.toggle('is-cut', cut && this.processedRemoved);
      this.updateMockup(url, cut && this.processedRemoved);
      if (this.bgToggle) {
        this.bgToggle.textContent = this.showOriginal ? 'Voir le dessin détouré' : 'Voir la photo d’origine';
        this.bgToggle.hidden = !(this.processedRemoved && this.originalIsImage);
      }
    }

    setBusy(on) {
      this.classList.toggle('is-processing', on);
      const badge = this.mockMedia && this.mockMedia.querySelector('.fm-mockup__badge');
      if (badge) badge.textContent = on ? 'Préparation de l’aperçu…' : 'Aperçu de votre tee-shirt';
    }

    revokeUrls() {
      [this.originalUrl, this.processedUrl].forEach((u) => { if (u && u.startsWith('blob:')) URL.revokeObjectURL(u); });
      this.originalUrl = null; this.processedUrl = null; this.processedRemoved = false; this.showOriginal = false;
    }

    updateMockup(url, cut) {
      const media = this.galleryMedia();
      if (!media) return;
      let box = media.querySelector('.fm-mockup');
      let badge = media.querySelector('.fm-mockup__badge');
      if (!url) { if (box) box.remove(); if (badge) badge.remove(); this.mockBox = null; this.updateZoom(null); return; }
      if (!box) {
        box = document.createElement('div');
        box.className = 'fm-mockup';
        box.innerHTML = '<div class="fm-mockup__print"></div>';
        media.appendChild(box);
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'fm-mockup__badge';
        badge.textContent = 'Aperçu de votre tee-shirt';
        media.appendChild(badge);
      }
      box.querySelector('.fm-mockup__print').style.backgroundImage = `url("${url}")`;
      box.classList.toggle('is-cut', !!cut);
      box.classList.toggle('is-raw', !cut);
      this.mockMedia = media; this.mockBox = box;
      const img = media.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', () => this.placeMockup(), { once: true });
      this.placeMockup();
      this.updateZoom(url, cut);
    }

    /* ---- Fenêtre de zoom (clic sur le tee-shirt) ----
       Dawn y affiche sa propre image du tee-shirt blanc. Tant qu'un dessin est choisi, on la remplace par une image
       fusionnée (tee-shirt + dessin, même zone d'impression, même rendu « multiply » que l'aperçu),
       et on remet l'image d'origine quand le dessin est retiré. */
    zoomImage(media) {
      const item = media.closest('.product__media-item');
      const toggle = item && item.querySelector('.product__media-toggle[data-media-id]');
      const id = toggle ? toggle.dataset.mediaId : (item && item.dataset.mediaId ? item.dataset.mediaId.split('-').pop() : '');
      if (!id) return null;
      const scope = this.closest('section') || document;
      const modal = scope.querySelector('product-modal') || document.querySelector('product-modal');
      return modal ? modal.querySelector(`img[data-media-id="${id}"]`) : null;
    }

    loadImage(src) {
      return new Promise((resolve, reject) => {
        const im = new Image();
        im.crossOrigin = 'anonymous';
        im.decoding = 'async';
        im.onload = () => resolve(im);
        im.onerror = reject;
        im.src = src;
      });
    }

    /* plus grande version du tee-shirt proposée par le srcset de la fenêtre de zoom */
    zoomTeeSrc(zimg) {
      let best = zimg.dataset.fmOrigSrc || '', bw = 0;
      (zimg.dataset.fmOrigSrcset || '').split(',').forEach((part) => {
        const m = part.trim().match(/^(\S+)\s+(\d+)w$/);
        if (m && +m[2] > bw) { bw = +m[2]; best = m[1]; }
      });
      return best.startsWith('//') ? window.location.protocol + best : best;
    }

    restoreZoom(zimg) {
      if (zimg && zimg.dataset.fmOrigSrc != null) {
        if (zimg.dataset.fmOrigSrcset) zimg.setAttribute('srcset', zimg.dataset.fmOrigSrcset);
        zimg.setAttribute('src', zimg.dataset.fmOrigSrc);
        delete zimg.dataset.fmOrigSrc;
        delete zimg.dataset.fmOrigSrcset;
        zimg.classList.remove('fm-zoom-preview');
      }
      if (this.zoomUrl) { URL.revokeObjectURL(this.zoomUrl); this.zoomUrl = null; }
    }

    async updateZoom(url, cut) {
      const token = (this.zoomToken = (this.zoomToken || 0) + 1);
      const media = this.galleryMedia();
      const zimg = media && this.zoomImage(media);
      if (!zimg) return;
      if (!url) { this.restoreZoom(zimg); return; }
      if (zimg.dataset.fmOrigSrc == null) {
        zimg.dataset.fmOrigSrc = zimg.getAttribute('src') || '';
        zimg.dataset.fmOrigSrcset = zimg.getAttribute('srcset') || '';
      }
      try {
        const [tee, art] = await Promise.all([this.loadImage(this.zoomTeeSrc(zimg)), this.loadImage(url)]);
        if (token !== this.zoomToken) return;
        const W = tee.naturalWidth, H = tee.naturalHeight;
        const aw = art.naturalWidth, ah = art.naturalHeight;
        if (!W || !H || !aw || !ah) return;
        const cv = document.createElement('canvas');
        cv.width = W; cv.height = H;
        const ctx = cv.getContext('2d');
        ctx.drawImage(tee, 0, 0, W, H);
        /* même placement que l'aperçu : dessin contenu dans la zone, centré en largeur, calé en haut */
        const [x, y, w, h] = this.area;
        const rw = w * W, rh = h * H, s = Math.min(rw / aw, rh / ah);
        const dw = aw * s, dh = ah * s;
        ctx.globalCompositeOperation = 'multiply';
        ctx.filter = cut ? 'saturate(1.06)' : 'contrast(1.12) brightness(1.06) saturate(1.1)';
        ctx.drawImage(art, x * W + (rw - dw) / 2, y * H, dw, dh);
        const blob = await new Promise((resolve) => cv.toBlob(resolve, 'image/webp', 0.92));
        if (!blob || token !== this.zoomToken) return;
        const old = this.zoomUrl;
        this.zoomUrl = URL.createObjectURL(blob);
        zimg.removeAttribute('srcset');
        zimg.setAttribute('src', this.zoomUrl);
        zimg.classList.add('fm-zoom-preview');
        if (old) setTimeout(() => URL.revokeObjectURL(old), 1500);
      } catch (_) { /* image impossible à charger : la fenêtre de zoom garde le tee-shirt seul */ }
    }

    /* ---- Vignette du panier ----
       Une petite copie du dessin détouré (500 px max, PNG transparent) part avec la commande dans la propriété
       cachée « _apercu » : le panier s'en sert pour montrer le tee-shirt avec le dessin. Le fichier « Dessin »
       envoyé à l'atelier reste la photo d'origine. */
    previewField() {
      if (this.previewInput) return this.previewInput;
      const inp = document.createElement('input');
      inp.type = 'file';
      inp.name = 'properties[_apercu]';
      inp.hidden = true;
      inp.tabIndex = -1;
      inp.setAttribute('aria-hidden', 'true');
      const formId = this.input.getAttribute('form');
      if (formId) inp.setAttribute('form', formId);
      this.input.insertAdjacentElement('afterend', inp);
      this.previewInput = inp;
      return inp;
    }

    clearPreviewFile() {
      if (this.previewInput) { try { this.previewInput.value = ''; } catch (_) { /* rien */ } }
    }

    async setPreviewFile(url, token) {
      try {
        if (typeof DataTransfer === 'undefined' || typeof File === 'undefined') return;
        const img = await this.loadImage(url);
        if (token !== this.token) return;
        const s = Math.min(1, 500 / Math.max(img.naturalWidth || 1, img.naturalHeight || 1));
        const cv = document.createElement('canvas');
        cv.width = Math.max(1, Math.round(img.naturalWidth * s));
        cv.height = Math.max(1, Math.round(img.naturalHeight * s));
        cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
        const blob = await new Promise((resolve) => cv.toBlob(resolve, 'image/png'));
        if (!blob || token !== this.token) return;
        const dt = new DataTransfer();
        dt.items.add(new File([blob], 'apercu-dessin.png', { type: 'image/png' }));
        this.previewField().files = dt.files;
      } catch (_) { /* pas de vignette détourée : le panier utilisera la photo d'origine */ }
    }

    get submitButton() {
      return this.form ? this.form.querySelector('[type="submit"][name="add"]') : null;
    }

    syncSubmit() {
      const btn = this.submitButton;
      if (!btn) return;
      const hasFile = this.input.files && this.input.files.length > 0;
      btn.toggleAttribute('data-fm-needs-file', !hasFile);
      btn.classList.toggle('fm-needs-file', !hasFile);
    }

    showError(msg) {
      this.error.textContent = msg;
      this.error.hidden = !msg;
      this.zone.classList.toggle('has-error', !!msg);
    }

    clear() {
      this.input.value = '';
      this.clearPreviewFile();
      this.filename.value = '';
      this.token = (this.token || 0) + 1;
      this.revokeUrls();
      this.thumb.removeAttribute('src');
      if (this.bgToggle) this.bgToggle.hidden = true;
      this.setBusy(false);
      this.thumb.hidden = true;
      this.nopreview.hidden = true;
      this.preview.hidden = true;
      this.updateMockup(null);
      this.empty.hidden = false;
      this.okEl.hidden = true;
      this.showError('');
      this.reset();
      this.syncSubmit();
    }

    validateFile(file) {
      if (!file) return 'Ajoutez le dessin de votre enfant avant de continuer.';
      const typeOk = OK_TYPES.includes(file.type) || OK_EXT.test(file.name);
      if (!typeOk) return 'Format non pris en charge. Envoyez une image JPEG, PNG, HEIC ou WebP.';
      if (file.size > this.maxMb * MB) return `Fichier trop lourd (${(file.size / MB).toFixed(1)} Mo). Maximum ${this.maxMb} Mo : réduisez la photo ou envoyez un JPEG.`;
      if (file.size < 30 * 1024) return 'Image très petite (moins de 30 Ko) : le rendu imprimé serait flou. Envoyez une photo en pleine résolution.';
      return '';
    }

    onFile(file) {
      const err = this.validateFile(file);
      if (err) {
        this.input.value = '';
        this.preview.hidden = true;
        this.empty.hidden = false;
        this.updateMockup(null);
        this.showError(err);
        this.syncSubmit();
        return;
      }
      this.showError('');
      this.filename.value = file.name;
      this.nameEl.textContent = file.name;
      this.sizeEl.textContent = file.size >= MB ? `${(file.size / MB).toFixed(1)} Mo` : `${Math.round(file.size / 1024)} Ko`;
      this.empty.hidden = true;
      this.preview.hidden = false;
      this.okEl.hidden = false;

      const token = (this.token = (this.token || 0) + 1);
      this.clearPreviewFile();
      this.revokeUrls();
      this.originalUrl = URL.createObjectURL(file);
      this.originalIsImage = ['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || /\.(jpe?g|png|webp)$/i.test(file.name);
      if (this.bgToggle) this.bgToggle.hidden = true;
      if (this.originalIsImage) {
        this.applyPreview(); /* photo d'origine tout de suite, remplacée par la version détourée dès qu'elle est prête */
      } else {
        this.thumb.hidden = true;
        this.nopreview.hidden = false;
        this.updateMockup(null);
      }
      if (this.detour && window.FmDetourage) {
        this.setBusy(true);
        window.FmDetourage.process(file).then((r) => {
          if (token !== this.token) { if (r.url.startsWith('blob:')) URL.revokeObjectURL(r.url); return; }
          this.processedUrl = r.url;
          this.processedRemoved = r.removed;
          this.applyPreview();
          if (r.removed) this.setPreviewFile(r.url, token);
        }).catch(() => { /* format illisible par le navigateur (HEIC hors Safari…) : pas d'aperçu, le fichier part quand même */ })
          .finally(() => { if (token === this.token) this.setBusy(false); });
      }
      this.syncSubmit();
    }

    /* API utilisée par product-form.js */
    validate() {
      const err = this.validateFile(this.input.files && this.input.files[0]);
      this.showError(err);
      if (err) {
        this.zone.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.zone.focus({ preventScroll: true });
      }
      return !err;
    }

    setProgress(pct) {
      this.progress.hidden = false;
      const p = Math.max(0, Math.min(100, Math.round(pct)));
      this.bar.style.width = p + '%';
      this.pct.textContent = p + ' %';
      this.progress.setAttribute('aria-valuenow', p);
      this.progress.classList.toggle('is-done', p >= 100);
    }

    reset() {
      this.progress.hidden = true;
      this.bar.style.width = '0%';
      this.pct.textContent = '0 %';
      this.progress.classList.remove('is-done');
    }

    fail(msg) {
      this.reset();
      this.showError(msg || 'L’envoi a été interrompu. Vérifiez votre connexion et réessayez : votre dessin est toujours sélectionné.');
    }
  }

  if (!customElements.get('fm-drawing-upload')) customElements.define('fm-drawing-upload', FmDrawingUpload);

  window.FmDrawingUpload = {
    find(form) { return form ? form.querySelector('fm-drawing-upload') : null; },
    validate(form) { const el = this.find(form); return el ? el.validate() : true; },
    progress(form, pct) { const el = this.find(form); if (el) el.setProgress(pct); },
    reset(form) { const el = this.find(form); if (el) el.reset(); },
    fail(form, msg) { const el = this.find(form); if (el) el.fail(msg); },
    hasFile(form) { const el = this.find(form); return !el || (el.input.files && el.input.files.length > 0); },
  };
})();
